<script setup lang="ts">
  import type { PrimitiveProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import type { ButtonVariants } from '.'
  import { Primitive } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'
  import { buttonVariants } from '.'

  interface Props extends PrimitiveProps {
    variant?: ButtonVariants['variant']
    size?: ButtonVariants['size']
    color?: ButtonVariants['color']
    shape?: ButtonVariants['shape']
    class?: HTMLAttributes['class']
    disabled?: boolean
    active?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    as: 'button',
    disabled: false,
    active: false,
  })
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :disabled="disabled"
    :class="cn(buttonVariants({ variant, size, color, shape, active }), props.class)"
  >
    <slot />
  </Primitive>
</template>
